<dx-popup
    [title]="request?.type | capitalCase"
    [(visible)]="visible"
    [fullScreen]="!!(screen.xSmallScreenChanged | async)"
    [width]="'80%'"
    [height]="'90%'"
    (onHidden)="onClose()"
    [wrapperAttr]="{'class':'form-popup'}"
    [animation]="{ show: { type: 'fadeIn', duration: 200 }, hide: { type: 'fadeOut', duration: 200 } }"
    [showCloseButton]="true"
>
    <div class="d-flex flex-column h-100">
        <div class="row mb-3">
            <div class="col-md-6 mb-2">
                <label class="fw-bold d-block">To:</label>
                <div class="text-break overflow-auto" style="max-height: 150px">
                    @for(email of splitEmails(formData?.to); track email){
                        <span class="badge bg-light text-dark me-1 mb-1">{{ email }}</span>
                    }
                </div>
            </div>
            <div class="col-md-6 mb-2">
                <label class="fw-bold d-block">Cc:</label>
                <div class="text-break overflow-auto" style="max-height: 150px">
                    @for(email of splitEmails(formData?.cc); track email){
                        <span class="badge bg-light text-dark me-1 mb-1">{{ email }}</span>
                    }
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label class="fw-bold d-block">Subject:</label>
            <div class="text-break">{{ formData?.subject }}</div>
        </div>
        <div class="d-flex flex-column flex-grow-1" style="min-height: 0;">
            <label class="fw-bold d-block mb-1">Body:</label>
            <iframe class="flex-grow-1 pt-3 w-100 border-0" [srcdoc]="getSafeHtml(formData?.body)"></iframe>
        </div>
    </div>
</dx-popup>
